module.exports = __webpack_public_path__ + "img/paamon_yes.a5551ac6.png";